/**
 * In-app "back" for the shells (2026-09-08, Kai: "iPhone doesn't have a built-in back button,
 * so we need an official one in the UI itself"). iOS convention is a leading chevron in the
 * navigation bar plus the left-edge swipe; Android has the system back. React Router's
 * BrowserRouter stores the history index as `history.state.idx`, so a page knows whether a
 * previous in-app screen exists (idx > 0) or whether it was opened cold (deep link, ad, email)
 * and must fall back to a sensible parent route instead of leaving the app or the site.
 */
export type BackTarget = { kind: 'back' } | { kind: 'to'; to: string };

export function historyIndex(state: unknown): number {
  if (state && typeof state === 'object' && 'idx' in state) {
    const idx = (state as { idx?: unknown }).idx;
    if (typeof idx === 'number' && Number.isFinite(idx)) return idx;
  }
  return 0;
}

export function canGoBack(state: unknown): boolean {
  return historyIndex(state) > 0;
}

/** history.back() when an in-app screen precedes this one, else replace with `fallback`. */
export function resolveBack(state: unknown, fallback: string): BackTarget {
  return canGoBack(state) ? { kind: 'back' } : { kind: 'to', to: fallback };
}
